const gate = document.getElementById('gate') as HTMLElement;
const app = document.getElementById('app') as HTMLElement;
const inviteInput = document.getElementById('inviteInput') as HTMLInputElement;
const inviteError = document.getElementById('inviteError') as HTMLElement;
const btnCreate = document.getElementById('btnCreate') as HTMLButtonElement;
const slotsPanel = document.getElementById('slotsPanel') as HTMLElement;

// --- Invite Code ---
let inviteCode = localStorage.getItem('notify-invite-code');

function getHeaders(): Record<string, string> {
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  if (inviteCode) h['X-Invite-Code'] = inviteCode;
  return h;
}

async function validateCode(code: string): Promise<boolean> {
  try {
    const res = await fetch('/api/invite/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    const data = await res.json();
    return data.valid;
  } catch {
    return false;
  }
}

function showApp() {
  gate.classList.add('hidden');
  app.classList.remove('hidden');
  loadSlots();
}

// Check stored code on load
if (inviteCode) {
  validateCode(inviteCode).then(valid => {
    if (valid) {
      showApp();
    } else {
      inviteCode = null;
      localStorage.removeItem('notify-invite-code');
    }
  });
}

// Gate: auto-validate on input (debounced)
let validateTimer: ReturnType<typeof setTimeout> | null = null;
let lastValidated = '';

async function tryValidate() {
  const code = inviteInput.value.trim();
  if (!code || code === lastValidated) return;
  lastValidated = code;

  inviteError.classList.add('hidden');

  const valid = await validateCode(code);
  // Check that input hasn't changed during the request
  if (inviteInput.value.trim() !== code) return;

  if (valid) {
    inviteCode = code;
    localStorage.setItem('notify-invite-code', code);
    showApp();
  } else {
    inviteError.classList.remove('hidden');
  }
}

inviteInput.addEventListener('input', () => {
  inviteError.classList.add('hidden');
  lastValidated = '';
  if (validateTimer) clearTimeout(validateTimer);
  validateTimer = setTimeout(tryValidate, 500);
});

// Keep Enter as fallback
inviteInput.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter') return;
  if (validateTimer) clearTimeout(validateTimer);
  tryValidate();
});

// Reset button state (bfcache)
window.addEventListener('pageshow', () => {
  btnCreate.disabled = false;
  btnCreate.textContent = 'Создать звонок';
});

// --- Service Worker ---
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}

// --- Create Room ---
btnCreate.addEventListener('click', async () => {
  btnCreate.disabled = true;
  btnCreate.textContent = 'Создаём…';

  try {
    const res = await fetch('/api/rooms', {
      method: 'POST',
      headers: getHeaders(),
    });
    if (!res.ok) {
      btnCreate.disabled = false;
      btnCreate.textContent = 'Создать звонок';
      return;
    }
    const { roomId } = await res.json();
    window.location.href = `/${roomId}`;
  } catch {
    btnCreate.disabled = false;
    btnCreate.textContent = 'Создать звонок';
  }
});

// --- Slots ---
interface Slot {
  slot_number: number;
  room_id: string;
}

let slots: Slot[] = [];

async function loadSlots() {
  if (!inviteCode) return;
  try {
    const res = await fetch('/api/slots', { headers: getHeaders() });
    if (!res.ok) return;
    const data = await res.json();
    slots = data.slots || [];
    renderSlots();
  } catch {}
}

function renderSlots() {
  const btns = slotsPanel.querySelectorAll('.slot-btn');
  btns.forEach(btn => {
    const num = parseInt((btn as HTMLElement).dataset.slot || '0', 10);
    const slot = slots.find(s => s.slot_number === num);
    if (slot) {
      btn.classList.remove('slot-empty');
      btn.classList.add('slot-bound');
    } else {
      btn.classList.add('slot-empty');
      btn.classList.remove('slot-bound');
    }
  });
}

slotsPanel.addEventListener('click', (e) => {
  const btn = (e.target as HTMLElement).closest('.slot-btn') as HTMLElement | null;
  if (!btn) return;
  const num = parseInt(btn.dataset.slot || '0', 10);
  const slot = slots.find(s => s.slot_number === num);
  if (slot) {
    window.location.href = `/${slot.room_id}`;
  }
});
